import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../../shared/models/component-messages/blocCommun/divers/step1';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { DIVERS } from '../../models/Typedivers';

@Component({
  selector: 'app-step1common',
  templateUrl: './step1common.component.html'
})
export class Step1CommonComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() divers: DIVERS;
  @Input() linkForRouter: string;
  @Input() formName: string;
  public current_uid = 'DIVERS';
  public step1 = new Step1();


  constructor(public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService) { }

  ngOnInit(): void {
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

}
